import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styles from './KommerTextRow.module.css';
import { format, parseISO } from "date-fns";
import locale from "date-fns/locale/nb";
import WatchlistActionButton from 'src/components/kommendefilmer/WatchlistActionButton';
import withWatchlistState from 'src/components/filmwebid/withWatchlistState';

//#region [Props]
type KommerTextRowProps = {
	dateFormat: "thisweek" | "thisyear" | "year";
	film: Movie;
};
//#endregion

//#region [Component]
export default function KommerTextRow({ dateFormat, film }: KommerTextRowProps) {
	if (!film.premiere) {
		return null;
	}
	const premDate = parseISO(film.premiere);
	let dateLabel: string;
	if (film.isPremiereConfirmed) {
		switch (dateFormat) {
			case "thisyear":
			case "thisweek":
				dateLabel = format(premDate, "EEEE dd. MM", { locale });
				break;
			case "year":
				dateLabel = format(premDate, "dd.MM.yyyy", { locale });
				break;
		}
	} else {
		dateLabel = format(premDate, "MMM. yyyy");
	}

	return <article className={styles.SRowArticle}>
		<FilmwebLink className={styles.STitleLink} to={`/film/${film.mainVersionId}`}><h1 className={styles.SMovieTitle}>{film.title}</h1></FilmwebLink>
		<div className={styles.SPremiere}>{dateLabel}</div>
		<WLSWatchlistButton className={styles.SWLSWatchlistButton} edi={film.mainVersionId} hideLabel/>
	</article>;
}
//#endregion

const WLSWatchlistButton = withWatchlistState(WatchlistActionButton);

//#region [Styles]
// migrated to KommerTextRow.module.css
//#endregion
